import React from 'react';

import { Box, Link, Typography } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import StatusIndicatorTooltip from 'common/components/StatusIndicatorTooltip';

const NameFormatter = ({ row }) => {
    const label = get(row, 'name', '-');
    const parentId = get(row, 'parent_field_segment_id', null);
    const status = get(row, 'status', null);
    const isGenerated = status === 'generated';
    const isBomExpress = row.is_bom_express;
    const to = isGenerated
        ? `/panel-layout/preview/${row.id}`
        : isBomExpress
          ? `/bom-express/${parentId}`
          : `/panel-layout/${parentId}`;
    return (
        <Box
            alignItems="center"
            display="flex"
            gap={1}
            sx={{ cursor: 'pointer', width: '100%' }}
        >
            <StatusIndicatorTooltip
                animated
                isApproved={row?.has_approbed || false}
                isGenerated={isGenerated}
            />
            <Link
                color="inherit"
                component={RouterLink}
                to={to}
                underline="none"
            >
                <Typography fontWeight="bold" variant="caption">
                    {label}
                </Typography>
            </Link>
        </Box>
    );
};

NameFormatter.propTypes = {
    row: PropTypes.object,
};

export default NameFormatter;
